import React, { FormEvent, ReactElement, useCallback } from 'react';

import StudioModal, {
  StudioModalProps,
} from '../../../../Modules/Studio/components/StudioModal/StudioModal';
import MenuBar from '../../MenuBar/MenuBar';
import ActionButtonsContainer from '../../../../Modules/Studio/components/StudioModal/ActionButtonsContainer';
import { SUBMIT_BUTTON_LABELS, SubmitButton } from '@3.0/Buttons';

const errorModalText = {
  ok: SUBMIT_BUTTON_LABELS.ok,
  sorryWeEncounteredAnError: 'Sorry, we encountered an error.',
  somethingWentWrong: 'Something Went Wrong',
};

type Props = {
  errorText?: string;
  onClose?: () => void;
  modalProps?: StudioModalProps;
};

const modalPropDefaults = {
  modalName: errorModalText.somethingWentWrong,
  modalWidth: '720px',
  modalHeight: '350px',
  showWarning: false,
  hideHelpBtn: true,
  showBackBtn: false,
  modalContainerProps: { 'data-testid': 'error-modal' },
};

const ErrorModal: React.FC<Props> = ({ errorText, onClose, modalProps }): ReactElement<any> => {
  const handleSubmit = useCallback(
    (evt: FormEvent<HTMLFormElement>) => {
      evt.preventDefault();
      if (onClose) {
        onClose();
      }
    },
    [onClose]
  );

  return (
    <StudioModal showError {...{ ...modalPropDefaults, ...modalProps }} closeModal={onClose}>
      <MenuBar mode="shade" variant="default" label="" actionButtons={[]} />
      <section className="flex-column pre flex-auto" style={{ padding: '40px 80px' }}>
        <div
          role="dialog"
          aria-labelledby="errorModalTitle"
          aria-describedby="errorModalDescription"
          className="flex-column flex items-center"
        >
          <h2 id="errorModalTitle" className="pa-24-bottom fs-18 ma0">
            {errorModalText.sorryWeEncounteredAnError}
          </h2>
          <div id="errorModalDescription" className="fs-16 ws-normal tc lh-28">
            {errorText}
          </div>
        </div>
      </section>
      <form onSubmit={handleSubmit}>
        <ActionButtonsContainer className="justify-end" isLegacy={false}>
          <SubmitButton data-testid="error-modal-ok-button" labelVariant={errorModalText.ok} />
        </ActionButtonsContainer>
      </form>
    </StudioModal>
  );
};

export default ErrorModal;
